"use client";

import { FC, ReactNode, MouseEvent } from "react";
import Button from "@mui/material/Button";

import { useStyles } from "./styles";

interface SecondaryButtonProps {
  children: string;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  textColor?: string;
  icon?: ReactNode;
  disabled?: boolean;
}

const SecondaryButton: FC<SecondaryButtonProps> = ({
  children,
  onClick = () => {},
  className = "",
  textColor,
  icon,
  disabled = false,
}) => {
  const { classes } = useStyles({ textColor, hasIcon: Boolean(icon) });

  return (
    <Button
      variant="contained"
      className={`${classes.button} ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      <div className={classes.buttonInner}>
        {children}
        {icon && <span className={classes.buttonIcon}>{icon}</span>}
      </div>
    </Button>
  );
};

export default SecondaryButton;
